import { render } from "./QuestionsComponent.vue?vue&type=template&id=44f42553&scoped=true&ts=true"
import script from "./QuestionsComponent.vue?vue&type=script&lang=ts"
export * from "./QuestionsComponent.vue?vue&type=script&lang=ts"

import "./QuestionsComponent.vue?vue&type=style&index=0&id=44f42553&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44f42553"]])

export default __exports__